import { UserPlus, Share2 } from "lucide-react";
import { toast } from "sonner";
import { downloadVCard } from "@/lib/vcard";
import { shareCard } from "@/lib/share";

export const SaveContact = () => {
    const handleVCard = () => {
        downloadVCard();
        toast.success("Contatto scaricato", {
            description: "Apri il file .vcf per salvare Mino in rubrica.",
        });
    };

    const handleShare = () => shareCard();

    return (
        <div data-testid="save-contact-section" className="flex flex-col gap-3">
            <button
                data-testid="vcard-download-button"
                onClick={handleVCard}
                className="group relative flex items-center justify-center gap-3 overflow-hidden rounded-xl bg-[#e2c075] px-6 py-4 transition-transform duration-300 active:scale-[0.98]"
            >
                <span className="absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-white/40 to-transparent transition-transform duration-700 group-hover:translate-x-full" />
                <UserPlus className="h-4 w-4 text-[#090a0c]" />
                <span className="font-code text-xs font-medium uppercase tracking-[0.22em] text-[#090a0c]">
                    Salva in rubrica
                </span>
            </button>
            <button
                data-testid="share-button"
                onClick={handleShare}
                className="flex items-center justify-center gap-3 rounded-xl border border-[rgba(226,192,117,0.3)] px-6 py-4 text-[#e2c075] transition-colors duration-300 hover:border-[rgba(226,192,117,0.6)] hover:bg-[rgba(226,192,117,0.06)]"
            >
                <Share2 className="h-4 w-4" />
                <span className="font-code text-xs font-medium uppercase tracking-[0.22em]">
                    Condividi il biglietto
                </span>
            </button>
        </div>
    );
};
